import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import type { InventoryListFormState } from '@openx/types/inventoryList';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router';
import { InventoryListsForm } from './components/InventoryLists/InventoryListForm/InventoryListsForm';
import { getInitialValues } from './components/InventoryLists/InventoryListForm/InventoryListsFormFields/components/utils';

export const InventoryListFormPage = () => {
  const { inventoryListId } = useParams<{ inventoryListId: string }>();
  const { useInventoryListByIdFetch, useSubmitInventoryList } = useAdministrationContext();
  const { submitForm, loading: formLoading } = useSubmitInventoryList(inventoryListId);
  const { loading, inventoryList } = useInventoryListByIdFetch(inventoryListId);
  const isEdit = Boolean(inventoryListId);
  const initialValues = useMemo(() => getInitialValues(inventoryList), [inventoryList]);

  const onSubmit = useCallback(
    (values: InventoryListFormState) => {
      submitForm(values, initialValues);
    },
    [submitForm, initialValues]
  );

  if (loading) {
    return <Loader />;
  }

  return <InventoryListsForm onSubmit={onSubmit} initialValues={initialValues} isEdit={isEdit} loading={formLoading} />;
};
